




















































































import FloorArea from "@/model/floorArea";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RepairContentList from "@/components/repair-content/repairContentList.vue";
import QTableHeader from "@/common/qTableHeader.vue";
@Component({
  name: "RepairContentHistory",
  components: {
    RepairContentList,
    QTableHeader,
  },
})
export default class RepairContentHistory extends Vue {
  @Prop()
  propertyId;
  @Prop({
    default: () => {
      return [];
    },
  })
  areaList: FloorArea[];

  public headers = [
    { id: "repair_date", name: "日付", order: "desc" },
    { id: "manage_number", name: "修繕箇所" },
    { id: "zip_code", name: "内容" },
    { id: "name", name: "償却残日数" },
    { id: "", name: "備考" },
    { id: "", name: "" },
  ];
  public search = {
    area_ids: [],
  };
  @Watch("areaList", { deep: true })
  changeAreaList() {
    this.search.area_ids = this.areaList.map((item) => item.id);
  }

  public statusOf(repairContent) {
    if (this.$ability.can("edit", "PropertyRepairContent")) {
      return repairContent.latestName;
    }
    return "detail";
  }

  public doSearch() {
    (this.$refs.repairList as RepairContentList).getRepairContentList(
      this.search
    );
  }
}
